import { CognitoUserPool } from 'amazon-cognito-identity-js';

let userPool: CognitoUserPool | null = null;

try {
  const userPoolId = process.env.REACT_APP_USER_POOL_ID;
  const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;

  if (!userPoolId || !clientId) {
    throw new Error(
      'Missing required Cognito configuration. Please ensure REACT_APP_USER_POOL_ID and REACT_APP_USER_POOL_CLIENT_ID are set.'
    );
  }

  const poolData = {
    UserPoolId: userPoolId,
    ClientId: clientId
  };

  userPool = new CognitoUserPool(poolData);
  console.log('Cognito User Pool initialized successfully');
} catch (error) {
  console.error('Failed to initialize Cognito User Pool:', error);
}

export default userPool;
